import { createPreloadableRoute } from "@ilabel/platform-core";

export const loginRoute = createPreloadableRoute(
  () => import("../features/login/login-page.js"),
  (module) => module.LoginPage,
);
export const operationConsoleRoute = createPreloadableRoute(
  () => import("../features/operation-console/operation-console-page.js"),
  (module) => module.OperationConsolePage,
);
export const workbenchRoute = createPreloadableRoute(
  () => import("../features/workbench/workbench-page.js"),
  (module) => module.WorkbenchPage,
);
export const projectManagementRoute = createPreloadableRoute(
  () => import("../features/project-management/project-management-page.js"),
  (module) => module.ProjectManagementPage,
);
export const datasetManagementRoute = createPreloadableRoute(
  () => import("../features/dataset-management/dataset-management-page.js"),
  (module) => module.DatasetManagementPage,
);
export const annotationDataManagementRoute = createPreloadableRoute(
  () =>
    import(
      "../features/annotation-data-management/annotation-data-management-page.js"
    ),
  (module) => module.AnnotationDataManagementPage,
);
export const configManagementRoute = createPreloadableRoute(
  () => import("../features/config-management/config-management-page.js"),
  (module) => module.ConfigManagementPage,
);
export const labelLibraryDetailRoute = createPreloadableRoute(
  () => import("../features/label-library-detail/label-library-detail-page.js"),
  (module) => module.LabelLibraryDetailPage,
);
export const teamMembersRoute = createPreloadableRoute(
  () => import("@ilabel/team-members"),
  (module) => module.TeamMembersPage,
);
export const profileSettingsRoute = createPreloadableRoute(
  () => import("../features/profile-settings/profile-settings-page.js"),
  (module) => module.ProfileSettingsPage,
);
export const uiPreviewRoute = createPreloadableRoute(
  () => import("./ui-preview-page.js"),
  (module) => module.UiPreviewPage,
);

export const loadOperationConsolePage = operationConsoleRoute.load;
export const preloadOperationConsolePage = operationConsoleRoute.preload;

const routePreloaders = new Map<string, () => Promise<void>>([
  ["/operation-console", operationConsoleRoute.preload],
  ["/workbench", workbenchRoute.preload],
  ["/project-management", projectManagementRoute.preload],
  ["/dataset-management", datasetManagementRoute.preload],
  ["/annotation-data-management", annotationDataManagementRoute.preload],
  ["/config-management", configManagementRoute.preload],
  ["/label-library-detail", labelLibraryDetailRoute.preload],
  ["/team-members", teamMembersRoute.preload],
  ["/profile-settings", profileSettingsRoute.preload],
]);

export function preloadVlaRoute(destination: string) {
  const pathname = destination.split(/[?#]/, 1)[0] || destination;
  return routePreloaders.get(pathname)?.() ?? Promise.resolve();
}
